
import _ from 'lodash';
import TableList from '@/components/TableList/index.vue';
import { exchangeCreationTypes } from '@/common/demand';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { channelList } from '@com/utils/channel';
import { orientation, closeTime, logoPosition, categories } from '@/common/material-metadata';
import DownloadButton from '@/components/DownloadButton/index.vue';
import clip from '@/utils/clipboard'; // use clipboard directly

export default {
  components: {
    TableList: TableList,
    DownloadButton: DownloadButton
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isDeliveryDetail: Boolean,
    taskActionType: {
      type: Number,
      default: 1
    },
    columnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    handleSelectionChange: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      tableConfig: {}
    };
  },

  computed: {
    innerList: function innerList() {
      if (_.isArray(this.list)) {
        return this.list.map(function (item) {
          return item;
        });
      }
      return [];
    },
    tableColumnConfig: function tableColumnConfig() {
      var _this = this;

      var findLabel = function findLabel(array, id) {
        var item = array.find(function (e) {
          return Number(e.value) === Number(id);
        });
        if (item && item.label) {
          return item.label;
        }
        return '-';
      };

      return [{
        label: '选择',
        prop: 'selection',
        type: 'selection',
        selectable: function selectable(row, index) {
          // 详情页逻辑
          // 当status为0，或者is_template不是undefined时，is_template为true
          if (_this.isDeliveryDetail) {
            if (row.status === 9) {
              return true;
            }
            return false;
          }
          // 提交逻辑，已经提交过的任务变灰不可选中
          if (_this.taskActionType === 1) {
            // 模板选择限制，status === 0未关联测试任务
            if (row.is_makable !== 0) {
              if (row.is_makable === 1 && row.status === 0) {
                return true;
              }
              return false;
            } else if (row.status === 0) {
              return true;
            }
          }

          // 更新，8自测 7待测试 1测试中 11压缩失败 12提测失败, 13 待广告主审核 10 待压缩审核
          if (_this.taskActionType === 2) {
            if ([8, 7, 1, 12, 11, 13, 10].indexOf(row.status) !== -1) {
              return true;
            }
          }
          // 提测 8自测
          if (_this.taskActionType === 3) {
            if ([8].indexOf(row.status) !== -1) {
              return true;
            }
          }
          // 删除 8自测 7待测试 1测试中 11压缩失败 12提测失败, 13 待广告主审核 10 待压缩审核
          if (_this.taskActionType === 4) {
            if ([8, 7, 1, 12, 11, 13, 10].indexOf(row.status) !== -1) {
              return true;
            }
          }

          return false;
        }
      }, {
        label: '平台',
        prop: 'platform'
      }, {
        label: '创意类型',
        prop: 'creation_types',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return exchangeCreationTypes(String(row.creation_type)) || '-';
          }
        }
      }, {
        label: '投放渠道/语言',
        prop: 'channels',
        width: 110,
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            if (row && row.channel_id) {
              var channels = String(row.channel_id).split(',');
              return channels.map(function (channel) {
                return useValueExchangeLabel(Number(channel), channelList) + ': ' + row.language;
              }).reduce(function (accumulator, currentValue) {
                return accumulator + '<div>' + currentValue + '</div>';
              }, '');
            }
            return '-';
          }
        },
        filters: this.languageAndChannel,
        filterMethod: this.filterLanguageAndChannel
      }, {
        label: '展示方向',
        prop: 'orientation',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return findLabel(orientation, row.orientation);
          }
        }
      }, {
        label: 'logo位置',
        prop: 'logo_position',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            return findLabel(logoPosition, row.logo_position);
          }
        }
      }, {
        label: '关闭时间',
        prop: 'close_time',
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            return findLabel(closeTime, row.close_time);
          }
        }
      }, {
        label: '素材类型',
        prop: 'category_id',
        params: {
          innerHTML: function innerHTML(_ref6) {
            var row = _ref6.row;

            return findLabel(categories, row.category_id);
          }
        }
      }, {
        label: '基础包ID',
        prop: 'basic_id',
        params: {
          innerHTML: function innerHTML(_ref7) {
            var row = _ref7.row;

            return row.basic_id !== 0 ? '<a href="#/repo/basic?platform=&search_field=id&keyword=' + row.basic_id + '&tag_ids=&page=1&page_size=15">' + row.basic_id + '</a>' : '-';
          }
        }
      }, {
        label: '测试任务Id',
        prop: 'submit_task_id',
        params: {
          innerHTML: function innerHTML(_ref8) {
            var row = _ref8.row;

            return row.submit_task_id !== 0 ? '<a href="#/butler/submitted-demand/task?search_field=id&keyword=' + row.submit_task_id + '">' + row.submit_task_id + '</a>' : '-';
          }
        }
      }, {
        prop: 'status',
        slot: 'test-status-cell'
      }, {
        slot: 'action-cell',
        prop: 'action-cell'
      }];
    },
    languageAndChannel: function languageAndChannel() {
      if (this.list) {
        // 语言
        var language = this.list.map(function (item) {
          return item.language;
        });
        // 渠道
        var channel = this.list.map(function (item) {
          return item.channel_id;
        });

        var channels = _.uniq(channel).map(function (item) {
          var val = useValueExchangeLabel(Number(item), channelList);
          return {
            text: val,
            value: Number(item)
          };
        });

        var languages = _.uniq(language).map(function (item) {
          return {
            text: item,
            value: item
          };
        });
        return languages.concat(channels);
      }
      return [];
    },


    // 过滤表数据
    filterColumnConfig: function filterColumnConfig() {
      var _this2 = this;

      var tempConfig = [];
      this.columnConfig.map(function (columnProp) {
        _this2.tableColumnConfig.map(function (item) {
          if (columnProp && item.prop === columnProp) {
            tempConfig.push(item);
          }
        });
      });

      return tempConfig;
    }
  },
  methods: {
    handleCopy: function handleCopy(text, event) {
      clip(text, event);
    },
    clearSelection: function clearSelection() {
      this.$refs.table.clearSelection();
    },
    filterLanguageAndChannel: function filterLanguageAndChannel(value, row, column) {
      return row.language === value || row.channel_id === value;
    }
  }
};